import { render, staticRenderFns } from "./PageCreateAccount.vue?vue&type=template&id=6dd6b212&scoped=true&"
import script from "./PageCreateAccount.vue?vue&type=script&lang=js&"
export * from "./PageCreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd6b212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd6b212')) {
      api.createRecord('6dd6b212', component.options)
    } else {
      api.reload('6dd6b212', component.options)
    }
    module.hot.accept("./PageCreateAccount.vue?vue&type=template&id=6dd6b212&scoped=true&", function () {
      api.rerender('6dd6b212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/createaccount/PageCreateAccount.vue"
export default component.exports